import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import HospitalCard from '../HospitalCard/HospitalCard';

const ProvinceModal = ({ 
    isOpen, 
    onClose, 
    provinceName, 
    centers, 
    onOpenMap, 
    onOpenPicture, 
    onCopy 
}) => {
    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div 
                className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 animate-in fade-in duration-300"
                onClick={onClose}
            />
            
            {/* Modal */}
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
                <div 
                    className="bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[85vh] overflow-hidden pointer-events-auto animate-in zoom-in-95 slide-in-from-bottom-4 duration-300"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header */}
                    <div className="sticky top-0 z-10 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white p-6 border-b-4 border-orange-500">
                        <div className="flex items-center justify-between">
                            <div>
                                <h2 className="text-2xl md:text-3xl font-black tracking-tight">
                                    จังหวัด{provinceName}
                                </h2>
                                <p className="text-blue-200 text-sm font-bold mt-2">
                                    พบ {centers.length} ศูนย์บริการ
                                </p>
                            </div>
                            <button
                                onClick={onClose}
                                className="p-3 rounded-2xl bg-white/10 hover:bg-white/20 border border-white/20 transition-all duration-300 active:scale-95"
                                aria-label="ปิด"
                            >
                                <XMarkIcon className="w-6 h-6" strokeWidth={2.5} />
                            </button>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="p-6 overflow-y-auto max-h-[calc(85vh-120px)] custom-scrollbar">
                        {centers.length > 0 ? (
                            <div className="space-y-4">
                                {centers.map((center, index) => (
                                    <HospitalCard
                                        key={center.hcode || index}
                                        index={index}
                                        data={center}
                                        onOpenMap={onOpenMap}
                                        onOpenPicture={onOpenPicture}
                                        onCopy={onCopy}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="py-20 text-center">
                                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-slate-100 flex items-center justify-center">
                                    <svg className="w-8 h-8 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <p className="text-slate-500 font-medium">ไม่พบข้อมูลศูนย์บริการในพื้นที่นี้</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: #f1f5f9;
                    border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }
            `}</style>
        </>
    );
};

export default ProvinceModal;
